import { render, staticRenderFns } from "./mdgk.vue?vue&type=template&id=4c586e8b&scoped=true&"
import script from "./mdgk.vue?vue&type=script&lang=js&"
export * from "./mdgk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c586e8b",
  null
  
)

export default component.exports